import { Block } from "../entities/Block";
import { Tower } from "../entities/Tower";
import { PhysicsSystem } from "./PhysicsSystem";
import { TowerSystem } from "./TowerSystem";

export enum JudgeResult {
  None,
  BlockEscaped,
  TowerFell,
  StageClear,
}

export class JudgeSystem {
  private physicsSystem: PhysicsSystem;
  private towerSystem: TowerSystem;
  private tower: Tower;

  constructor(
    physicsSystem: PhysicsSystem,
    towerSystem: TowerSystem,
    tower: Tower
  ) {
    this.physicsSystem = physicsSystem;
    this.towerSystem = towerSystem;
    this.tower = tower;
  }

  /** Check for block escape success */
  checkEscapedBlocks(): Block[] {
    const escaped: Block[] = [];
    for (const block of this.tower.blocks) {
      if (block.isEscaping && !block.isRemoved) {
        if (this.physicsSystem.hasEscaped(block)) {
          escaped.push(block);
        }
      }
    }
    return escaped;
  }

  /** Judge the current frame */
  judge(): { result: JudgeResult; escapedBlocks: Block[] } {
    // Check for escaped blocks
    const escapedBlocks = this.checkEscapedBlocks();
    if (escapedBlocks.length > 0) {
      // Check if stage is clear (no active blocks remain after removal)
      const remaining = this.towerSystem.getRemainingCount() - escapedBlocks.length;
      if (remaining <= 0) {
        return { result: JudgeResult.StageClear, escapedBlocks };
      }
      return { result: JudgeResult.BlockEscaped, escapedBlocks };
    }

    // Check tower tilt (only when no block is currently escaping)
    const hasEscapingBlock = this.tower.blocks.some(
      (b) => b.isEscaping && !b.isRemoved
    );
    if (!hasEscapingBlock && this.towerSystem.isTiltExceeded()) {
      return { result: JudgeResult.TowerFell, escapedBlocks: [] };
    }

    return { result: JudgeResult.None, escapedBlocks: [] };
  }
}
